export default __webpack_public_path__ + "static/media/SA.6a02c215.svg";